import { render } from "./choose-car.vue?vue&type=template&id=c3fb4302&scoped=true&ts=true"
import script from "./choose-car.vue?vue&type=script&lang=ts"
export * from "./choose-car.vue?vue&type=script&lang=ts"

import "./choose-car.vue?vue&type=style&index=0&id=c3fb4302&lang=scss&scoped=true"

import exportComponent from "/Users/panren/Desktop/太平洋网络/discount-topics-wap-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3fb4302"]])

export default __exports__